import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import useMedia from 'use-media';
import useWindowSize from '../../../hooks/useWindowSize';
import Input from '../../ui/forms/Input';
import InputDisabled from '../../ui/forms/InputDisabled';
import BoxedInputWrap from '../../ui/forms/BoxedInputWrap';
import Label from '../../ui/forms/Label';
import BoxedInputContainer from '../../ui/forms/BoxedInputContainer';
import TooltipImg from '../../ui/forms/TooltipImg';
import infoimage from '../../../assets/images/icons8-info-48.png';

const BoxedInput = (props) => {
    const { disabled, label, error, warning, warningMsg,value, ...inputProps } = props;
    const inputRef = useRef({});
    const [isEllipsis, setIsEllipsis] = useState(false);

    const tooltipId = useMemo(() => `tooltip_id_${props.name}`, [props.name]);
    const isWide = useMedia({ minWidth: '700px' });
    const windowSize = useWindowSize(!isWide && disabled);

    useEffect(() => {
        const ellipsis =  !!(inputRef.current && inputRef.current.offsetHeight && inputRef.current.scrollHeight && inputRef.current.offsetWidth && inputRef.current.scrollWidth ) && (inputRef.current.offsetHeight < inputRef.current.scrollHeight || inputRef.current.offsetWidth < inputRef.current.scrollWidth)
        setIsEllipsis(ellipsis); 
    }, [inputRef.current, windowSize.width, isWide, value]);

    useEffect(() => ReactTooltip.rebuild(), [isEllipsis]);
    
    return(
        <BoxedInputContainer>
            <Label>{label}</Label>
            <BoxedInputWrap disabled={disabled}>
                {
                    disabled ? 
                        <InputDisabled ref={inputRef} {...inputProps}>{value}</InputDisabled> : 
                        <Input disabled={disabled} {...inputProps} value={value}/>
                }
                { disabled && value && isEllipsis && <TooltipImg src={infoimage} data-for={tooltipId} data-tip={value} />}
            </BoxedInputWrap>
            { error && <Label isValidationMsg>{error}</Label>}
            { warning && <Label isValidationMsg>{warningMsg}</Label>}
            <ReactTooltip effect="solid" html={false} place="top" id={tooltipId}/>
        </BoxedInputContainer>
    );
}

export default BoxedInput;
